import React, { useState } from 'react';
import Gallery from '../../Assets/images/gallery.svg';
import Library from '../../Assets/images/library.svg';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Report = () => {
  const { t } = useTranslation();

  return (
    <div className="test_block no_decor">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h3 className="main-content__main-products desktop-title tac">{t('report.title')}</h3>
                    <div className="desktop-content tac"><p>{t('report.description')}</p></div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 col-lg-offset-2 col-md-offset-2">
                    <Link to="/photo">
                        <div className="cont_lib">
                            <div className="">
                                <img src={Gallery} alt={t('report.photoReports')} />
                            </div>
                            <div className="tittle_report">
                                <h4>{t('report.photoReports')}</h4>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                    <Link to="/document" >
                        <div className="cont_lib">
                            <div className="">
                                <img src={Library} alt={t('report.annualReports')} />
                            </div>
                            <div className="tittle_report">
                                <h4>{t('report.annualReports')}</h4>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Report;